import React from 'react';
import './Mockup.css';

function Mockup() {
    return (
        <section className="mockup-section" aria-label="Пример интерфейса AIColl">
            <div className="mockup-inner">
                <img
                    src="/mockup-devices.webp"
                    alt="Экран входа AIColl на ноутбуке и смартфоне"
                    className="mockup-image"
                    loading="lazy"
                />
            </div>
        </section>
    );
}

export default Mockup;
